export default "__VITE_ASSET__a55b8c4e__"